module.exports = __webpack_public_path__ + "static/img/get_bunnyposy.826d9144.webp";